import { getAPI } from '../axios-api.js';
import axios from 'axios';

export async function logServerError(error) {
  const isAxios = axios.isAxiosError(error); // Evaluates strictly to true or false


  // Extract useful error details from Axios response
  const errorPayload = {
    error: error.message ? error.message : "",
    status_code: error.response?.status? error.response.status: '',
    response_data: error.response?.data ? error.response.data : '',
    is_axios_error: isAxios,
    error_code: isAxios ? (error.code || 'UNKNOWN_AXIOS') : (error.name || 'JS_ERROR'),
    user_agent: navigator.userAgent // Helps identify device/browser
  };

  // For desktop debugging
  console.error(errorPayload);

  // Send payload to backend server
  try {
    await getAPI.post('/complainLog/submission-errors/', errorPayload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`
      }
    });
  } catch (logErr) {
    // Fail silently so logging code doesn't break user flow
    console.warn('Failed to send log to server:', logErr);
  }
}